import { SAVE_USER, REFRESH_USER } from '../constants/actionTypes'
import { fetchGraphUserDetails } from '../providers/user'

export const initUser = user => ({
  type: SAVE_USER,
  user,
})

export const refreshUser = user => ({
  type: REFRESH_USER,
  user,
})

export const PHONE_FIELDS = {
  optIn: 'opt_in',
  verified: 'verified',
}

export const updatePhoneValue =
  (targetPhoneNumber, field, value) => async (dispatch, getStore) => {
    const updatedUser = Object.assign({}, getStore().user)

    const latestPhone = updatedUser.party?.phones.find(
      phone => phone.number === targetPhoneNumber
    )
    if (!latestPhone) {
      updatedUser.party?.phones.unshift({
        number: targetPhoneNumber,
        [field]: value,
      })
    } else {
      latestPhone[field] = value
    }
    dispatch(refreshUser(updatedUser))
  }

export const fetchUser = () => async dispatch => {
  const user = await fetchGraphUserDetails()

  dispatch(refreshUser(user))
}

const CREATE = 'CREATE'
const UPDATE = 'UPDATE'
const DELETE = 'DELETE'

export const upsertReoPurchaseProfile =
  profileData => async (dispatch, getStore) => {
    const user = getStore().user
    let updatedPurchaseProfiles = user.purchase_profiles.slice()

    const { action, reo_purchase_profile: newProfile } = profileData

    switch (action) {
      case CREATE:
        updatedPurchaseProfiles.push(newProfile)
        break
      case UPDATE:
        updatedPurchaseProfiles = updatedPurchaseProfiles.map(oldProfile => {
          if (oldProfile.offer_template_id === newProfile.offer_template_id) {
            return newProfile
          }

          return oldProfile
        })
        break
      case DELETE:
      // TODO: this message doesn't get emitted on purchase profile deletion
    }

    dispatch({
      type: SAVE_USER,
      user: { ...user, purchase_profiles: updatedPurchaseProfiles },
    })
  }
